import { Avalista } from './../model/avalista';
import {
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { cloneDeep, isEmpty } from 'lodash';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { finalize, take } from 'rxjs/operators';
import { Data } from '../../../shared/partner/data';
import { RenavanPartner } from '../../../shared/partner/renavan-partner';
import { FichaModalAvalistaComponent } from '../../ficha-timeline/ficha-modal-avalista/ficha-modal-avalista.component';
import { CustomModalService } from '../../../shared/modais/custom-modal/custom-modal.service';
import * as toastr from 'toastr';
import { FichaService } from '../../ficha-veiculo.service';
import { ModalMessageComponent } from '.././../../shared/modais/modal-message/modal-message.component';
import { FichaCadastroEvent } from '../ficha-cadastro.event';
import { removeFichaContent } from '../helpers/salvarFicha';
import { VeiculoProprioFinaliza } from '../model/veiculo';
import { appSettings } from './../../../../environments/app.setings';
import { FichaCadastro } from './../ficha-cadastro';
import { ModalPesadosBrasilComponent } from './modal-pesados-brasil/modal-pesados-brasil.component';
import { LoginStorage } from './../../../login/login.storage';
import { Originador } from './../../../services/pesados-brasil/originador.interface';
import { allTelefones, getFoneEmpresa } from '../../../shared/helper/utils';
import { Cliente } from '../model/cliente';
import { LeadsOnlineService } from '../../../produtos/leads/services/leads.service';

@Component({
  selector: 'app-ficha-cadastro-observacao',
  templateUrl: './ficha-cadastro-observacao.component.html',
  styleUrls: ['./ficha-cadastro-observacao.component.scss'],
})
export class FichaCadastroObservacaoComponent implements OnDestroy, OnInit {
  @ViewChild('modalMessage', { static: true })
  modalMessage: ModalMessageComponent;

  @ViewChild('modalPesadosBrasil', { static: true })
  modalPesadosBrasil: ModalPesadosBrasilComponent;

  @ViewChild('renavanInput', { static: true }) renavanInput: ElementRef;

  @Input() fichaCadastro: FichaCadastro;

  bsModalRef: BsModalRef;

  private subsProposta: Subscription;

  observacao: string;
  isSaving = true;
  countCaracteres: number = 0;
  hideClose: boolean = true;
  exibeIncluirAvalista: boolean = false;
  avalistasIncluidos: any[] = [];
  isLoading = false;
  isleads: boolean = false;

  public originador: Originador;

  constructor(
    private fichaService: FichaService,
    private fichaEvent: FichaCadastroEvent,
    private modalService: CustomModalService,
    private loginStorage: LoginStorage,
    private leadsOnlineService: LeadsOnlineService
  ) {}

  ngOnInit() {
    this.originador = this.loginStorage.originator;
    this.initLeadsOnline();
  }

  ngOnDestroy() {
    if (this.subsProposta) {
      this.subsProposta.unsubscribe();
    }
  }

  validaRenavam() {
    if (this.fichaCadastro.codRenavam) {
      if (RenavanPartner.isValid(this.fichaCadastro.codRenavam)) {
        this.fichaCadastro.garantiasOriginais = this.fichaCadastro.garantias;
        this.fichaCadastro.garantias = [
          {
            codRenavam: this.fichaCadastro.codRenavam,
          },
        ];
        this.fichaCadastro.proposta['garantias'] = this.fichaCadastro.garantias;
      } else {
        this.renavanInput.nativeElement.focus();
        this.hideClose = true;
        this.modalMessage.show(
          'Número de Renavam inválido! Favor tentar novamente'
        );
      }
    }
  }

  onChangeObs(event) {
    const limite = 0;
    this.countCaracteres = limite + event.length;
  }

  onClickPrevious() {
    this.fichaCadastro.onClickPrevious();
  }

  formatDateMiliseconds(data) {
    return Data.toMilissegundos(data);
  }

  setPayload() {
    const clienteObj = this.fichaCadastro.proposta.cliente;
    try {
      this.fichaCadastro.proposta.cliente = JSON.parse(
        JSON.stringify(this.fichaCadastro._client.proposta)
      );
    } catch (error) {
      this.fichaCadastro.proposta.cliente = JSON.parse(
        JSON.stringify(this.getClientProposta(this.fichaCadastro._client))
      );
    }
    this.setPayloadCliente(clienteObj);
    this.setPayloadVeiculoProprio();

    if (this.fichaCadastro.hasAvalista()) {
      let avalistaObj = this.fichaCadastro.proposta.avalistas;

      this.fichaCadastro.proposta.avalistas = [];
      this.fichaCadastro.avalistas.map((avalista) => {
        this.fichaCadastro.proposta.avalistas.push(
          JSON.parse(
            JSON.stringify(
              avalista.proposta
                ? avalista.proposta[0]
                : this.getAvalistaProposta(avalista)[0]
            )
          )
        );
      });
      if (!avalistaObj) {
        avalistaObj = this.fichaCadastro.proposta.avalistas;
      }
      this.setPayloadAvalista(avalistaObj);
    } else {
      this.fichaCadastro.proposta.avalistas = [];
      this.setAvalistaFromModal();
    }

    this.fichaCadastro.proposta.avalistas.map((avalista) => {
      if (avalista && avalista.grauParentescoCliente) {
        avalista.grauParentesco = avalista.grauParentescoCliente;
        delete avalista.grauParentescoCliente;
      }

      if (
        avalista &&
        avalista.dadoProfissional &&
        avalista.dadoProfissional.endereco &&
        !avalista.dadoProfissional.endereco.endereco
      ) {
        delete avalista.dadoProfissional.endereco;
      }

      if (avalista && avalista.clienteReferencias) {
        avalista.clienteReferencias.map((ref) => {
          if (
            ref.idGrauRelacionamento !== null &&
            ref.idGrauRelacionamento !== undefined &&
            (ref.idGrauRelacionamento === 0 ||
              Number(ref.idGrauRelacionamento) === 0)
          ) {
            delete ref.idGrauRelacionamento;
          }
        });
      }
    });

    if (this.observacao) {
      if (this.observacao.length > 0) {
        this.fichaCadastro.proposta['observacoes'] = this.observacao;
      }
    }

    this.fichaCadastro.proposta.portarDivida = 'N';

    removeFichaContent();
  }

  getAvalistaProposta(avalista: Avalista) {
    return [
      {
        dataNascimento: this.formatDateMiliseconds(avalista.dataNascimento),
        id: avalista.id,
        cpf: avalista.cpf ? avalista.cpf.replace(/\D/g, '') : avalista.cpf,
        nome: avalista.nome,
        renda: avalista.renda,
        email: avalista.email,
        nomeMae: avalista.nomeMae,
        nomePai: avalista.nomePai,
        idTipoDocumento: String(avalista.idTipoDocumento),
        rgIe: avalista.rgIe,
        rgIeUf: this.isleads ? avalista.rgIeUf : undefined,
        rgIeDt: this.formatDateMiliseconds(avalista.rgIeData),
        grauParentescoCliente: avalista.grauParentescoCliente,
        rgIeEmissor: avalista.rgIeEmissor,
        idEstadoCivil: avalista.idEstadoCivil,
        idNacionalidade: avalista.idNacionalidade,
        naturalDe: avalista.naturalDe,
        naturalDeUf: avalista.naturalDeUf,
        clientePpe:
          avalista.clientePpe === 'false' || avalista.clientePpe === 'N'
            ? 'N'
            : 'S',
        valorPatrimonio: avalista.valorPatrimonio,
        telefones: allTelefones(avalista.telefones),
        enderecos: this.enderecosPayload(
          avalista.enderecos,
          avalista.enderecoCorrespondencia
        ),
        tipoEnderecoCorresp: avalista.tipoEnderecoCorrespondencia,
        dadoProfissional: {
          idClasseProfissional: avalista.dadoProfissional.idClasseProfissional,
          idProfissao: avalista.dadoProfissional.idProfissao,
          idGrupoProfissao:
            avalista.dadoProfissional.profissao.idGrupoProfissao,
          nomeEmpresa: avalista.dadoProfissional.nomeEmpresa,
          telefone: getFoneEmpresa(avalista.dadoProfissional.telefoneEmpresa),
          endereco: !isEmpty(avalista.dadoProfissional.empresa.endereco)
            ? avalista.dadoProfissional.empresa.endereco
            : undefined,
        },
        clienteReferencias: [
          {
            nome: avalista.avalistaReferencia.nome,
            idGrauRelacionamento:
              avalista.avalistaReferencia.idGrauRelacionamento,
            telefone: getFoneEmpresa(avalista.avalistaReferencia.telefone),
          },
        ],
        veiculoEmSeuNome: !isEmpty(avalista.veiculoEmSeuNome)
          ? avalista.veiculoEmSeuNome
          : undefined,

        temProximo: avalista.temProximo,
      },
    ];
  }

  enderecosPayload(...data) {
    return data
      .filter((endereco) => endereco.idTipoEndereco)
      .map((item) => {
        return {
          idTipoEndereco: item.idTipoEndereco,
          uf: item.uf,
          cidade: item.cidade,
          endereco: item.endereco,
          bairro: item.bairro,
          numero: item.numero,
          complemento: item.complemento,
          cep: item.cep,
        };
      });
  }

  getClientProposta(client: Cliente) {
    return {
      id: client.id,
      cpf: client.cpf.replace(/\D/g, ''),
      nome: client.nome,
      renda: String(client.renda),
      email: client.email,
      nomeMae: client.nomeMae,
      nomePai: client.nomePai,
      idTipoDocumento: client.idTipoDocumento,
      rgIe: client.rgIe,
      rgIeUf: client.rgIeUf,
      rgIeDt: this.formatDateMiliseconds(client.rgIeData),
      rgIeEmissor: client.rgIeEmissor,
      idEstadoCivil: client.idEstadoCivil,
      idNacionalidade: client.idNacionalidade,
      naturalDe: client.naturalDe,
      naturalDeUf: client.naturalDeUf,
      clientePpe:
        client.clientePpe === 'false' || client.clientePpe === 'N' ? 'N' : 'S',
      valorPatrimonio: client.valorPatrimonio,
      condutorCaminhao: client.condutorCaminhao ? client.condutorCaminhao : 'N',
      tipoTransporte: client.tipoTransporte,
      tipoTransporteOutro: client.tipoTransporteOutro,
      tipoComprovanteRenda: client.tipoComprovanteRenda,
      rendaFutura: client.rendaFutura,
      empresaPrestacaoServico: !isEmpty(client.empresaPrestacaoServico)
        ? this.empresaPrestacaoServicoPayload(client.empresaPrestacaoServico)
        : undefined,
      telefones: allTelefones(client.telefones),
      enderecos: this.enderecosClientPayload(
        client.enderecos,
        client.enderecoCorrespondencia
      ),
      tipoEnderecoCorresp: client.tipoEnderecoCorrespondencia,
      dadoProfissional: {
        idClasseProfissional: client.dadoProfissional.idClasseProfissional,
        idProfissao: client.dadoProfissional.idProfissao,
        idGrupoProfissao: client.dadoProfissional.idGrupoProfissao,
        nomeEmpresa: client.dadoProfissional.nomeEmpresa,
        telefone: getFoneEmpresa(client.dadoProfissional.telefoneEmpresa),
        endereco: !isEmpty(client.dadoProfissional.empresa.endereco)
          ? client.dadoProfissional.empresa.endereco
          : undefined,
        tempoExperienciaRamo: client.dadoProfissional.tempoExperienciaRamo,
        familiaresRamo: client.dadoProfissional.familiaresRamo,
      },
      clienteReferencias: client.clienteReferencias,
    };
  }

  empresaPrestacaoServicoPayload(empresaPrestacaoServico) {
    if (
      empresaPrestacaoServico &&
      empresaPrestacaoServico.ddd &&
      empresaPrestacaoServico.numero
    ) {
      const { ddd, numero } = getFoneEmpresa(empresaPrestacaoServico.telefone);
      return {
        ...empresaPrestacaoServico,
        ddd,
        telefone: numero,
      };
    }
    return undefined;
  }

  enderecosClientPayload(...data) {
    return data
      .filter((endereco) => endereco.idTipoEndereco)
      .map((item) => {
        return {
          idTipoEndereco: item.idTipoEndereco,
          uf: item.uf,
          cidade: item.cidade,
          endereco: item.endereco,
          bairro: item.bairro,
          numero: item.numero,
          complemento: item.complemento,
          cep: item.cep,
          tempoResidencia: item.tempoResidencia,
          condicaoResidencia: item.condicaoResidencia,
        };
      });
  }

  setPayloadVeiculoProprio() {
    this.fichaCadastro.proposta.cliente.veiculoProprio = JSON.parse(
      JSON.stringify(this.fichaCadastro.veiculoProprio)
    );
    this.setPayloadImplementoVeiculo();
  }

  setPayloadImplementoVeiculo() {
    if (
      !this.fichaCadastro.proposta.cliente.veiculoProprio ||
      !this.fichaCadastro.proposta.cliente.veiculoProprio.length
    ) {
      return;
    }

    this.fichaCadastro.proposta.cliente.veiculoProprio =
      this.fichaCadastro.proposta.cliente.veiculoProprio.map(
        (vp: VeiculoProprioFinaliza) => {
          const implemento = this.fichaCadastro.veiculoProprioCaminhao.find(
            (vpc) => vpc.info && vpc.info.veiculoPlaca === vp.placa
          );
          if (implemento) {
            vp.marca = implemento.info.veiculoMarca;
            vp.anoModelo = implemento.info.veiculoAno;
            vp.modelo = implemento.info.veiculoModelo;
            vp.versao = implemento.info.veiculoVersao;
            vp.tempoPossui = implemento.info.tempoCaminhao;
            vp.possuiImplemento = implemento.implemento.veiculoImplemento
              ? 'S'
              : 'N';

            if (implemento.implemento.veiculoImplemento) {
              vp.marcaImplemento = implemento.implemento.veiculoMarca
                ? implemento.implemento.veiculoMarca.id
                : undefined;
              vp.modeloImplemento = implemento.implemento.veiculoModelo
                ? implemento.implemento.veiculoModelo.id
                : undefined;
              vp.anoImplemento = implemento.implemento.veiculoAno;
            }

            vp.quitado = implemento.quitado.veiculoQuitado ? 'S' : 'N';
            if (!implemento.quitado.veiculoQuitado) {
              vp.valorParcelas = Number(implemento.quitado.valorParcela || 0);
              vp.totalParcelasQuitadas = Number(
                implemento.quitado.parcelasQuitada || 0
              );
              vp.totalParcelas = Number(implemento.quitado.totalParcela || 0);
              vp.nomeCredor =
                (implemento.quitado.banco &&
                  implemento.quitado.banco.descricao) ||
                undefined;
            }
          }
          return vp;
        }
      );
  }

  setPayloadCliente(clienteObj) {
    this.fichaCadastro.proposta.cliente.id = clienteObj.id;
    if (clienteObj.renda !== undefined) {
      this.fichaCadastro.proposta.cliente.renda = clienteObj.renda;
    }

    if (!this.fichaCadastro.isPesados) {
      delete this.fichaCadastro.proposta.cliente.condutorCaminhao;
    }

    this.fichaCadastro.proposta.cliente.enderecos.map((endereco) => {
      endereco.tempoResidencia = Number(endereco.tempoResidencia);
    });

    if (
      this.fichaCadastro.proposta.cliente.dadoProfissional &&
      this.fichaCadastro.proposta.cliente.dadoProfissional.endereco &&
      this.fichaCadastro.proposta.cliente.dadoProfissional.endereco
        .tempoResidencia &&
      this.fichaCadastro.proposta.cliente.dadoProfissional.endereco
        .tempoResidencia !== '' &&
      this.fichaCadastro.proposta.cliente.dadoProfissional.endereco
        .tempoResidencia !== 0
    ) {
      this.fichaCadastro.proposta.cliente.dadoProfissional.endereco.tempoResidencia =
        Number(
          this.fichaCadastro.proposta.cliente.dadoProfissional.endereco
            .tempoResidencia
        );
    }

    if (
      this.fichaCadastro.proposta.cliente.dadoProfissional &&
      this.fichaCadastro.proposta.cliente.dadoProfissional.endereco &&
      this.fichaCadastro.proposta.cliente.dadoProfissional.endereco &&
      !this.fichaCadastro.proposta.cliente.dadoProfissional.endereco.endereco
    ) {
      this.fichaCadastro.proposta.cliente.dadoProfissional.endereco = undefined;
    }

    if (
      this.fichaCadastro.proposta.cliente &&
      this.fichaCadastro.proposta.cliente.clienteReferencias &&
      this.fichaCadastro.proposta.cliente.clienteReferencias.length > 0
    ) {
      this.fichaCadastro.proposta.cliente.clienteReferencias.map((ref) => {
        if (ref.telefone && !ref.telefones) {
          ref.telefones = [ref.telefone];
          delete ref.telefone;
        }
      });
    }

    this.validateClientProfessionalAddress();
  }

  setPayloadAvalista(avalistaObj) {
    if (this.fichaCadastro.proposta.avalistas.length > 0) {
      this.fichaCadastro.proposta.avalistas.forEach((avalista, index) => {
        if (avalistaObj && avalistaObj[index]) {
          avalista.id = avalistaObj[index].id;
          avalista.cpf = avalistaObj[index].cpf;
          avalista.renda = avalistaObj[index].renda;
          avalista.dataNascimento = avalistaObj[index].dataNascimento;
          avalista.grauParentescoCliente = Number(
            avalistaObj[index].grauParentescoCliente
          );
          avalista.telefones.push(avalistaObj[index].telefones[0]);

          avalista.veiculoProprio = JSON.parse(
            JSON.stringify(
              (avalistaObj[index].veiculoProprio
                ? Array.isArray(avalistaObj[index].veiculoProprio)
                  ? avalistaObj[index].veiculoProprio
                  : [avalistaObj[index].veiculoProprio]
                : Array.isArray(avalistaObj[index].veiculoEmSeuNome)
                ? avalistaObj[index].veiculoEmSeuNome
                : [avalistaObj[index].veiculoEmSeuNome]) || []
            )
          );
        }

        avalista.enderecos.map((endereco) => {
          endereco.tempoResidencia = Number(endereco.tempoResidencia);
        });

        avalista.dadoProfissional.endereco.tempoResidencia = Number(
          avalista.dadoProfissional.endereco.tempoResidencia
        );

        if (avalista.idNacionalidade > 1) {
          avalista.naturalDe = 'EX';
          avalista.naturalDeUf = 'EX';
        }

        delete avalista.veiculoEmSeuNome;

        if (
          avalista.dadoProfissional.endereco &&
          Object.keys(avalista.dadoProfissional.endereco).length === 0
        ) {
          delete avalista.dadoProfissional.endereco;
        }
      });

      this.setAvalistaFromModal();
    }
  }

  validateClientProfessionalAddress() {
    if (
      this.fichaCadastro.proposta.cliente.dadoProfissional.endereco &&
      Object.keys(this.fichaCadastro.proposta.cliente.dadoProfissional.endereco)
        .length === 0
    ) {
      delete this.fichaCadastro.proposta.cliente.dadoProfissional.endereco;
    }
  }

  setAvalistaFromModal() {
    if (this.avalistasIncluidos) {
      this.avalistasIncluidos.map((avalista) => {
        this.fichaCadastro.proposta.avalistas.push(avalista);
      });
    }
  }

  onClickNext() {
    if (this.originador && this.originador.originador) {
      this.modalPesadosBrasil.show();
    } else {
      this.setPayload();
      this.saveProposta();
    }
  }

  abrirInclusaoAvalista() {
    const initialState = {
      fichaCadastro: this.fichaCadastro,
      avalistasIncluidos: this.avalistasIncluidos,
    };
    this.bsModalRef = this.modalService.show(FichaModalAvalistaComponent, {
      ...appSettings.MODAL_PARAMS,
      initialState,
    });
    this.bsModalRef.content.cpfCliente =
      this.fichaCadastro.proposta.cliente.cpf;
    (<FichaModalAvalistaComponent>(
      this.bsModalRef.content
    )).onCloseModal.subscribe((body) => {
      this.avalistasIncluidos.push(body.avalistas[0].proposta);
      this.hideClose = false;
    });
  }

  removerAvalista(i) {
    this.modalMessage.show('Deseja remover o avalista?', 'Sim', 'Não');
    this.modalMessage.ok
      .pipe(take(1))
      .subscribe(() => this.avalistasIncluidos.splice(i, 1));
  }

  get canAddAvalista() {
    if (this.fichaCadastro.proposta.avalistas) {
      return (
        this.fichaCadastro.proposta.avalistas.length +
          this.avalistasIncluidos.length <
        3
      );
    }
    return this.avalistasIncluidos.length < 3;
  }

  private removeVeiculoProprioSeNaoExistirNenhum(value: any): any {
    if (value.veiculoProprio && !value.veiculoProprio.length) {
      delete value.veiculoProprio;
    }
    return value;
  }

  private removeTelefonesInvalidos(telefones: any[]): any {
    if (!telefones || !telefones.length) {
      return telefones;
    }
    return telefones.filter((f) => !!f.numero);
  }

  private getPropostaFormatada(): any {
    const proposta = cloneDeep(this.fichaCadastro.proposta);
    proposta.avalistas = proposta.avalistas.map((value) =>
      this.removeVeiculoProprioSeNaoExistirNenhum(value)
    );
    proposta.cliente = this.removeVeiculoProprioSeNaoExistirNenhum(
      proposta.cliente
    );

    if (
      proposta.cliente.clienteReferencias &&
      proposta.cliente.clienteReferencias.length
    ) {
      proposta.cliente.clienteReferencias =
        proposta.cliente.clienteReferencias.map((referencia) => ({
          ...referencia,
          telefones: this.removeTelefonesInvalidos(referencia.telefones),
        }));
    }

    if (proposta.cliente.telefones && proposta.cliente.telefones.length) {
      proposta.cliente.telefones = this.removeTelefonesInvalidos(
        proposta.cliente.telefones
      );
    }

    return proposta;
  }

  private getLeadsOriginatorType() {
    return this.leadsOnlineService.getOriginatorType()
      ? parseInt(this.leadsOnlineService.getOriginatorType())
      : null;
  }

  saveProposta() {
    this.isLoading = true;
    if (this.isleads) {
      if (this.getLeadsOriginatorType()) {
        this.fichaCadastro.proposta.tipoOriginador =
          this.getLeadsOriginatorType();
      }
      this.subsProposta = this.fichaService
        .finalizarSimulacaoLeads({
          proposta: this.parseProposalToLeads(this.fichaCadastro.proposta),
        })
        .pipe(finalize(() => (this.isLoading = false)))
        .subscribe(
          (res: any) => {
            this.handleFinalizeSuccess(res);
          },
          (err) => {
            this.handleFinalizeError();
          }
        );
    } else {
      let body;
      if (this.originador && this.originador.originador) {
        body = {
          proposta: this.getPropostaFormatada(),
          tipoOriginador: this.originador.typesOrigination[0].code,
        };
      } else {
        body = { proposta: this.getPropostaFormatada() };
      }
      this.subsProposta = this.fichaService
        .finalizarSimulacao(body)
        .pipe(finalize(() => (this.isLoading = false)))
        .subscribe(
          (res: any) => {
            this.handleFinalizeSuccess(res);
          },
          (err) => {
            this.handleFinalizeError();
          }
        );
    }
  }

  parseProposalToLeads(proposal: any) {
    if (proposal && proposal.cliente) {
      proposal.cliente.fatca = proposal.cliente.fatca ? 'S' : 'N';
    }
    if (proposal && proposal.avalistas && proposal.avalistas.length) {
      proposal.avalistas = proposal.avalistas.map((avalista) => {
        const aval = avalista;
        delete aval.rgIeUf;
        return aval;
      });
    }
    return proposal;
  }

  private handleFinalizeError() {
    this.hideClose = true;
    this.modalMessage.show('Falha na Comunicação, verifique sua conexão.');
    this.isSaving = false;
  }

  private handleFinalizeSuccess(res: any) {
    if (res.proposta) {
      this.fichaCadastro.proposta = res;
    }
    this.isSaving = false;
    this.fichaCadastro.onClickNext();
    this.fichaEvent.nextStep();
    this.putDataClient();
  }

  async initLeadsOnline() {
    try {
      const response = await this.fichaService.getOriginadorLeads();
      this.isleads = response.originadorLeads;
    } catch (e) {
      toastr.warning(
        'Erro ao consultar tipo de originador Leads Online. Caso seja um parceiro Leads, favor contatar o suporte',
        'Atenção'
      );
    }
  }

  private putDataClient() {
    this.fichaService
      .putRecoverFullDataProposal(this.fichaCadastro.recoverData)
      .pipe(take(1))
      .subscribe();
  }

  confirmarPropostaPesadosBrasil() {
    this.setPayload();
    this.saveProposta();
  }
}
